import { StubPage } from "./stub-page";

export function ServicesPage() {
  return (
    <StubPage
      title="Services"
      description="Placeholder services route."
    />
  );
}
